import { render } from "./EcosystemReportsTab.vue?vue&type=template&id=74f6107d"
import script from "./EcosystemReportsTab.vue?vue&type=script&lang=js"
export * from "./EcosystemReportsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__